import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import styles from "./OmOs.module.css";
import { fetchArticles } from "../services/articles";

export default function Article() {
  const { id } = useParams();
  const [article, setArticle] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchArticles()
      .then((articles) => {
        const found = articles.find((a) => a.id === id);
        setArticle(found);
        setLoading(false);
      })
      .catch((e) => {
        setError("Kunne ikke hente artikel.");
        setLoading(false);
      });
  }, [id]);

  if (loading) return <div className={styles.omOsContainer}>Indlæser artikel...</div>;
  if (error) return <div className={styles.omOsContainer}>{error}</div>;
  if (!article) return <div className={styles.omOsContainer}>Artiklen blev ikke fundet.</div>;

  return (
    <div className={styles.omOsContainer}>
      <section className={styles.omOsCard}>
        <div style={{ width: "100%" }}>
          <h2 style={{ fontSize: "2rem", marginBottom: "1.5rem", color: "#2e3b47" }}>{article.title}</h2>
          {article.image && (
            <img src={article.image} alt={article.title} style={{ maxWidth: "100%", marginBottom: "1.5rem", borderRadius: "0.5rem" }} />
          )}
          <p style={{ color: "#7c898b", marginBottom: "1.5rem" }}>{article.date}</p>
          <div style={{ marginBottom: "2rem" }}>{article.content || article.excerpt}</div>
          <a href="/articles" style={{ color: "#2e3b47", textDecoration: "underline" }}>← Tilbage til artikler</a>
        </div>
      </section>
    </div>
  );
}
